import logo from "./logo.svg";
import "./App.css";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { Home } from "./features/home/pages/home.page";
import { ThemeProvider } from "styled-components";
import { theme } from "./infrastructure/theme";

function App() {
  return (
    <div className="">
      <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" exact element={<Home />} />
        </Routes>
      </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
